import { useCallback } from 'react';

import type { ModelLead } from '@app/api/Leads/types';
import { replaceLatestRegistryLead } from '@app/pages/Leads/model/latestRegistryResultSlice';
import { useAppDispatch } from '@app/store';

// Targeted single-lead update for the accepted registry result that does NOT
// subscribe to the leads array (no `useAppSelector`). Per-row cells use it for
// optimistic responsible / funnel-stage updates so editing one row does not
// re-render every other row when the shared result changes.
export const useReplaceLatestRegistryLead = () => {
  const dispatch = useAppDispatch();

  return useCallback(
    (lead: ModelLead) => {
      dispatch(replaceLatestRegistryLead(lead));
    },
    [dispatch]
  );
};
